import { useSelector } from 'react-redux';
import { isGamificationEnabled } from '../../../gamification/utils/GamificationUtils';
import { MainMenu } from '@intigral/ui';
import { IStore } from '../../../../interfaces/StoreTypes';
import useLanguage from '../../../../hooks/useLanguage';
import { Link } from 'react-router-dom';
import { __ } from '../../../../translations';
import { useContext } from 'react';
import { EVENT } from '../../../../contexts/MixpanelConstants';
import { MixpanelContext } from '../../../../contexts/MixpanelContext';
import { useLogout } from '../../hooks/useLogout';
import { MenuItem } from '@intigral/shared/components/MenuList';
import { FontIcon } from '@intigral/shared';
import { getUserInfo } from '../../../../utils/user';
import { isGuestUser } from '../../../../config/guestMode';

export const MobileItem = () => {
    const isGuest = isGuestUser(getUserInfo());
    if (isGuest) {
        return null;
    }
    const gamificationConfig = isGamificationEnabled();
    const { selectedProfile } = useSelector((state: IStore) => state.profile);
    const language = useLanguage();
    const { logoutUser } = useLogout();
    const { track }: any = useContext(MixpanelContext);

    const rewardUrl = language === 'en' ? '/en/rewards' : '/rewards';
    const accountUrl = language === 'en' ? '/en/account' : '/account';
    const profileSettingUrl = language === 'en' ? '/en/profile-settings' : '/profile-settings';

    const handleLogOut = (e) => {
        e?.preventDefault();
        logoutUser();
    };

    return (
        <>
            {gamificationConfig?.enable && (
                <MainMenu
                    nav={[
                        {
                            href: rewardUrl,
                            text: __('rewards_menu_link'),
                            icon: 'reward',
                            item: { linkComponent: Link },
                            flag: __('rewards_menu_new_tag'),
                        },
                    ]}
                    onClick={() => {
                        track(EVENT.GAMIFICATION.REWARDS_DASHBORAD_VIEWED, {
                            'Screen Name': 'More Screen',
                        });
                    }}
                    data-test-id="profile-menu-rewards"
                />
            )}
            {!selectedProfile?.kidsMode && (
                <MainMenu
                    nav={[
                        {
                            href: accountUrl,
                            text: __('profile_my_account'),
                            icon: 'user',
                            item: { linkComponent: Link },
                        },
                        {
                            href: profileSettingUrl,
                            text: __('profile_settings'),
                            icon: 'settings',
                            item: { linkComponent: Link },
                        },
                    ]}
                />
            )}
            {/* {!selectedProfile?.kidsMode && (
                <MenuItem variant="link" onClick={handleLogOut} data-test-id="profile-menu-logout">
                    <FontIcon md="smaller" name="exit" size="smaller" />
                    {__('settings_logout')}
                </MenuItem>
            )} */}
            {!selectedProfile?.kidsMode && (
                <MainMenu
                    nav={[
                        {
                            href: '',
                            text: __('settings_logout'),
                            icon: 'exit',
                            item: { linkComponent: Link },
                        },
                    ]}
                    onClick={handleLogOut}
                />
            )}
        </>
    );
};
